// extracted by mini-css-extract-plugin
export var poweredByContainer = "PoweredBy-module--poweredByContainer--7d2ce";